import React from 'react';
import classNames from 'classnames';

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
          <a href="https://publico.menur.app/termos/plataforma/" rel="noopener noreferrer">Termos de Serviço</a>
        </li>
        <li>
          <a href="https://publico.menur.app/privacidade/" rel="noopener noreferrer">Privacidade</a>
        </li>
      </ul>
    </nav>
  );
}

export default FooterNav;